const userTypes = {
    NONE: 1,
    OWNER: 2,
    TEACHER: 3,
    STUDENT: 4
}

export default userTypes;
